import { ensureValidToken } from '@/core/auth/token-manager'
import { appConfig } from '@/shared/config/app-config'
import { setSupportWidgetConfig } from './support-globals'

// Where embed.js is served from. Same env var that proxies /api/support/*
// in dev — keeps a single knob for the support-live-chat origin.
const SUPPORT_BASE_URL =
  import.meta.env.VITE_SUPPORT_PROXY_TARGET ?? appConfig.supportApiUrl

let initialized = false

export function setupSupport(): void {
  if (initialized || typeof window === 'undefined') return
  initialized = true

  setSupportWidgetConfig({
    getAuthToken: () => ensureValidToken(),
  })

  const script = document.createElement('script')
  script.src = `${SUPPORT_BASE_URL}/embed.js`
  script.async = true
  document.head.appendChild(script)
}
